import React, {useEffect, useState} from 'react';
import {Navigate} from 'react-router-dom';
import {onAuthStateChanged} from "firebase/auth";
import {logInfo} from "../shared/services/logger.service";
import {firebaseAuth} from "../shared/services/firebase.service";

interface AuthGuardProps {
  children: React.ReactNode;
}

type AuthStatus = 'loading' | 'authed' | 'unauthed';

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const [status, setStatus] = useState<AuthStatus>('loading');

  useEffect(() => {
    // Firebase restores the persisted session asynchronously, so we must wait for
    // the auth state to resolve before deciding. The self-contained-auth deep-link
    // flow also lands here, but only after signInWithCustomToken() has established a
    // real session — so a live Firebase user is the single source of truth.
    const unsubscribe = onAuthStateChanged(firebaseAuth, (user) => {
      setStatus(user ? 'authed' : 'unauthed');
    });
    return unsubscribe;
  }, []);

  if (status === 'loading') {
    return null;
  }

  if (status === 'unauthed') {
    logInfo('User is not authenticated, redirecting to login');
    return <Navigate to="/login" replace/>;
  }

  return <>{children}</>;
};

export default AuthGuard;
